import {
  Alert,
  AlertTitle,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  ModalAcceptButton,
  ModalCancelButton,
} from "../../constants/component.constants";
import { ResponsiveRow } from "../../constants/layout.constants";
import ModalContainerModule from "../modules/modalContainer";
import EmptyOverlay from "../overlays/emptyOverlay";
import { useEffect, useState } from "react";
import {
  isArray,
  isEmptyArray,
  isEmptyString,
  isNullUndefined,
} from "../../util/util";
import { getIdTypes } from "../../services/list.service";
import { personOrgSearch } from "../../services/shared.service";

export default function ContractContactModal(props) {
  /**
   *
   * REQUIRED PROPS
   *
   * handleContactClose
   * handlePersonOrgSelect
   * searchPersonOrg
   *
   * contactModal
   * contactTableRows
   * selectedContract
   * contractType
   *
   */

  const [contactSearched, setContactSearched] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [idTypes, setIdTypes] = useState([]);
  const [idTypeSearch, setIdTypeSearch] = useState("");
  const [idNoSearch, setIdNoSearch] = useState("");
  const [foundTenant, setFoundTenant] = useState([]);
  const [loading, setLoading] = useState(false);

  function searchPersonOrg() {
    let data = {
      searchType: "Individual",
      idType: idTypeSearch,
      idNumber: idNoSearch,
      organizationName: "",
    };
    setLoading(true);
    personOrgSearch(data).then((response) => {
      if (
        !isNullUndefined(response) &&
        isArray(response) &&
        !isEmptyArray(response)
      ) {
        props.setShowAddNewContact(false);
      } else {
        props.setShowAddNewContact(true);
      }
      setFoundTenant(response);
      setLoading(false);
    });
  }

  const handleContactClear = () => {
    setIdTypeSearch("");
    setIdNoSearch("");
    setFoundTenant([]);
  };

  function handleIdTypeChange(event) {
    let value = event.target.value;
    setIdTypeSearch(value);
  }

  function onTextChange(event) {
    let searchText = event.target.value;
    setIdNoSearch(searchText);
  }

  useEffect(() => {
    let tmp = "";
    if (
      !isNullUndefined(
        props.selectedContract && props.selectedContract.billingCode,
      )
    ) {
      tmp = `(` + props.selectedContract.billingCode + `)`;
    }
    tmp = props.contractType + " " + tmp + " Contact";
    setModalTitle(tmp);
  }, [props]);

  useEffect(() => {
    getIdTypes().then((data) => setIdTypes(data));
  }, []);

  const getAddContactsTitle = () => {
    switch (props.contractType) {
      case "Lease":
        return "Add New Next of Kin";
      case "Ownership":
        return "Add New Next of Kin";
      case "Subscription":
        return "Add New Contacts";
      default:
        return "Add New Contacts";
    }
  };

  return (
    <ModalContainerModule
      size={props.contractType === "Organization" ? "sm" : "md"}
      cancel={props.handleContactClose}
      openModal={props.contactModal}
      modalTitle={modalTitle}
    >
      <ResponsiveRow
        item
        sx={{
          width: "100%",
          height: "100%",
          flexDirection: { xs: "column", lg: "row" },
          flexWrap: "nowrap",
          justifyContent: { xs: "flex-start", lg: "space-between" },
          alignItems: { xs: "center", lg: "flex-start" },
          overflowY: "auto",
          padding: 0,
        }}
      >
        <ResponsiveRow
          sx={{
            width: "100%",
            height: { xs: "auto", lg: "100%" },
            flexDirection: "column",
            flexWrap: "nowrap",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            margin: "10px auto 20px auto",
            padding: "10px",
          }}
        >
          <Typography
            sx={{ marginBottom: "5px" }}
            id="modal-modal-title"
            variant="h5"
            component="h4"
          >
            {getAddContactsTitle()}
          </Typography>
          <Alert severity="info" sx={{ width: "100%", height: "auto" }}>
            Use this form to search for an existing individual or create new
            contact person.
          </Alert>
          <ResponsiveRow
            sx={{
              justifyContent: "flex-start",
              alignItems: "center",
              width: "100%",
              height: "auto",
              padding: "10px",
            }}
          >
            <ResponsiveRow
              container
              sx={{
                width: "100%",
                height: "auto",
                justifyContent: {
                  xs: "center",
                  lg: "space-between",
                },
                alignItems: "flex-start",
                padding: 0,
              }}
            >
              <FormControl sx={{ width: { xs: "100%", lg: "50%" } }}>
                <InputLabel>ID Type</InputLabel>
                <Select
                  label="ID Type"
                  sx={{ width: { xs: "100%", lg: "90%" } }}
                  id={"idTypeSearch"}
                  value={idTypeSearch}
                  onChange={(event) => handleIdTypeChange(event)}
                >
                  {idTypes.length > 0 ? (
                    idTypes.map(function (idType, i) {
                      return (
                        <MenuItem key={i} value={idType.value}>
                          {idType.label}
                        </MenuItem>
                      );
                    }, this)
                  ) : (
                    <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                  )}
                </Select>
              </FormControl>
              <FormControl
                item
                sx={{
                  width: { xs: "100%", lg: "50%" },
                  marginBottom: "5px",
                }}
              >
                <InputLabel>ID Number</InputLabel>
                <OutlinedInput
                  label="ID Number"
                  sx={{ width: { xs: "100%", lg: "90%" } }}
                  id={"idNoSearch"}
                  value={idNoSearch}
                  onChange={(searchText) => onTextChange(searchText)}
                  inputProps={
                    <TextField
                      sx={{
                        width: {
                          xs: "100%",
                          lg: "90%",
                        },
                      }}
                    />
                  }
                />
              </FormControl>
              <ResponsiveRow
                item
                sx={{
                  justifyContent: {
                    xs: "center",
                    lg: "flex-end",
                  },
                  marginTop: "20px",
                  width: "100%",
                  height: "auto",
                }}
              >
                <ModalAcceptButton
                  variant="contained"
                  type="button"
                  onClick={() => {
                    setContactSearched(true);
                    searchPersonOrg();
                  }}
                  sx={{
                    backgroundColor: "#037171",
                    margin: {
                      xs: "10px 0 0 ",
                      lg: "0 0 0 10px",
                    },
                    width: { xs: "100%", lg: "150px" },
                    height: "40px",
                  }}
                  disabled={
                    isEmptyString(idNoSearch) || isEmptyString(idTypeSearch)
                  }
                >
                  Search
                </ModalAcceptButton>
                <ModalCancelButton
                  variant="contained"
                  type="submit"
                  onClick={() => {
                    setContactSearched(false);
                    handleContactClear();
                  }}
                  sx={{
                    margin: {
                      xs: "10px 0 0 ",
                      lg: "0 0 0 10px",
                    },
                    width: { xs: "100%", lg: "150px" },
                    height: "40px",
                  }}
                  color="error"
                >
                  Clear
                </ModalCancelButton>
              </ResponsiveRow>

              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}

              {!loading &&
                contactSearched === true &&
                foundTenant.length === 0 && (
                  <Alert
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      marginTop: "20px",
                      padding: "20x 0 0 0",
                    }}
                    severity="error"
                  >
                    <AlertTitle color="error">No Individuals found</AlertTitle>
                    <Typography sx={{ width: "100%" }}>
                      There were no individuals found with that ID number. Would
                      you like to create a new individuals?
                    </Typography>
                    <ResponsiveRow
                      sx={{
                        width: "100%",
                        justifyContent: "flex-end",
                        height: "auto",
                      }}
                    >
                      <Grid sx={{ width: "100%" }}>
                        <ModalAcceptButton
                          onClick={() =>
                            props.showAddNewContactForm(
                              idNoSearch,
                              idTypeSearch,
                            )
                          }
                          sx={{
                            width: {
                              xs: "100%",
                              lg: "100px",
                            },
                          }}
                        >
                          Yes
                        </ModalAcceptButton>
                        <ModalCancelButton
                          onClick={props.handleContactClose}
                          sx={{
                            width: {
                              xs: "100%",
                              lg: "100px",
                            },
                          }}
                        >
                          No
                        </ModalCancelButton>
                      </Grid>
                    </ResponsiveRow>
                  </Alert>
                )}
            </ResponsiveRow>
            {!loading && foundTenant.length > 0 && (
              <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {foundTenant.map(function (tenant, i) {
                      return (
                        <TableRow key={i}>
                          <TableCell>{tenant.name}</TableCell>
                          <TableCell>
                            <ModalAcceptButton
                              variant="contained"
                              type="submit"
                              onClick={() => {
                                setContactSearched(false);
                                props.handlePersonOrgSelect(tenant);
                                handleContactClear();
                              }}
                              sx={{
                                backgroundColor: "#037171",
                              }}
                            >
                              Add
                            </ModalAcceptButton>
                          </TableCell>
                        </TableRow>
                      );
                    }, this)}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </ResponsiveRow>
        </ResponsiveRow>

        {props.contractType !== "Organization" && (
          <ResponsiveRow
            sx={{
              width: "100%",
              height: { xs: "auto", lg: "100%" },
              justifyContent: "flex-start",
              alignItems: "flex-start",
              padding: "0",
              margin: "10px auto 20px auto",
            }}
          >
            <Typography
              sx={{ marginBottom: "5px" }}
              id="modal-modal-title"
              variant="h5"
              component="h4"
            >
              Contacts
            </Typography>
            {props.contactTableRows ? (
              <TableContainer sx={{ height: "100%", width: "100%" }}>
                <Table
                  sx={{ minWidth: 20 }}
                  aria-label="simple table"
                  stickyHeader
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          width: "30%",
                          color: "#037171",
                        }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "25%",
                          color: "#037171",
                        }}
                      >
                        Phone Number
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "25%",
                          color: "#037171",
                        }}
                      >
                        Email
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "20%",
                          color: "#037171",
                        }}
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      height: "100px",
                      overflowY: "auto",
                      textAlign: "center",
                    }}
                  >
                    {props.contactTableRows}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <ResponsiveRow
                sx={{
                  width: "100%",
                  height: "150px",
                  justifyContent: "center",
                  margin: "auto",
                }}
              >
                <EmptyOverlay />
              </ResponsiveRow>
            )}
          </ResponsiveRow>
        )}
      </ResponsiveRow>
    </ModalContainerModule>
  );
}
